import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/telegram-theme.css';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// Global error handler to catch script errors
window.addEventListener('error', (event) => {
  console.error('Global script error caught:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });
  
  // Prevent the error from being logged as "Script error" in console
  if (event.message === 'Script error.') {
    console.warn('⚠️ Generic script error detected - this is usually caused by CORS or external scripts');
  }
  
  // Don't prevent default behavior, just log it
  return false;
});

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  
  // Don't prevent default behavior for development
  if (process.env.NODE_ENV === 'development') {
    console.warn('⚠️ Unhandled promise rejection in development mode');
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
); 